import { createAction } from 'redux-actions';
import { change } from 'redux-form';
import { map } from 'lodash';
import { batchActions } from 'redux-batched-actions';
import {
  INFORMATION_DETAIL_FETCH,
  INFORMATION_DETAIL_SUCCESS,
  INFORMATION_DETAIL_FAILURE
} from './actionTypes';
import api from '../../services/api';
import { INFORMATION_FORM_NAME } from '../InformationForm/constants';

//<<<---INFORMATION-DETAIL--->>>
export const informationDetailFetch = createAction(INFORMATION_DETAIL_FETCH);
export const informationDetailSuccess = createAction(
  INFORMATION_DETAIL_SUCCESS
);
export const informationDetailFailure = createAction(
  INFORMATION_DETAIL_FAILURE
);

export const fetchInformationDetail = (id, lang) => async dispatch => {
  dispatch(informationDetailFetch());
  try {
    const { data } = await api.get(`information/${id}/${lang}`);

    const fieldNames = [
      'title',
      'description',
      'header',
      'headerImageSmall',
      'image',
      'slug',
      'subtitle',
      'content'
    ];

    const fieldChangeActions = map(fieldNames, fieldName =>
      change(INFORMATION_FORM_NAME, fieldName, data[fieldName])
    );
    fieldChangeActions.push(
      change(INFORMATION_FORM_NAME, 'headerImageLarge', {
        src: `https://api.alfadent.ikiguys.net${data.headerImageLarge}`
      })
    );

    dispatch(batchActions(fieldChangeActions));
    dispatch(informationDetailSuccess());
  } catch (error) {
    dispatch(informationDetailFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/InformationDetail/actions.js